import React from "react";

const Billable = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M17.824 27.355c0-3.988 3.067-7.361 6.952-7.77v-9.406L16.597 2H5.76A2.749 2.749 0 003 4.76v21.777a2.749 2.749 0 002.76 2.76h12.371a5.952 5.952 0 01-.307-1.942zm-2.556-23.31l6.134 6.134h-6.134V4.045zm1.33 19.731h-1.33v1.33h-2.76v-1.33H9.85v-2.76h5.418v-1.33h-4.09c-.715 0-1.328-.613-1.328-1.328v-4.09c0-.715.613-1.329 1.329-1.329h1.329v-1.431h2.76v1.329h2.76v2.76h-5.52v1.33h4.09c.715 0 1.329.613 1.329 1.329v4.089c.102.818-.512 1.431-1.33 1.431z"
            fill={fill}
        />
        <path className="u_fill"
            d="M25.697 20.71a6.632 6.632 0 00-6.646 6.645A6.632 6.632 0 0025.697 34a6.632 6.632 0 006.645-6.645 6.632 6.632 0 00-6.645-6.646zm3.782 4.498l-4.396 4.6c-.102.103-.204.103-.307.103-.102 0-.204 0-.306-.103l-2.045-2.249c-.205-.204-.205-.613 0-.818l.307-.306c.204-.205.613-.205.817 0l1.33 1.329 3.578-3.68c.204-.205.613-.205.818 0l.306.306c.103.204.103.613-.102.818z"
            fill={fill}
        />
    </svg>
);

export default Billable;